import React, { memo, useState } from "react";
import { IQ_API_BASE_URL } from "../../../../../config/apiConfig";
import {
  getUrlDetailsObj,
  getUserStatsObject,
  recordActivity,
  getTabType,
} from "../../../../../services/commonService";
import axios from "axios";
import { useLocation, useParams } from "react-router-dom";
import IOSSpinner from "../../../../HtmlElements/IOSSpinner";
import StatusIndicator from "../../../genericComponents/resizeableTable/StatusIndicator";

const GenericDocumentTableComp = ({
  documents,
  formatDate,
  baseUrl,
  title,
}) => {
  const [activeDownloadId, setActiveDownloadId] = useState(null);
  const { accountId, accountName, clientName, competitorName } = useParams();
  const tab_name = getTabType("documents") || "";
  const pageParsedData = getUrlDetailsObj(useLocation, useParams);

  const downloadFile = async (id, type = "pdf", title = "") => {
    try {
      setActiveDownloadId(id);
      const docType =
        type === "xlsx" ? "application/vnd.ms-excel" : "application/pdf";
      const response = await axios.post(
        `${IQ_API_BASE_URL}/company/download_file`,
        null,
        {
          responseType: "blob",
          params: { filingVersionId: id },
        }
      );
      const newBlob = new Blob([response.data], { type: docType });
      const url = window.URL.createObjectURL(newBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${competitorName} ${title} document`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      const userStat = getUserStatsObject(
        tab_name,
        "document_download",
        "Page Source: " + competitorName,
        window.location.href,
        accountId
      );
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
    } catch (error) {
      console.error("Error downloading the file", error);
    } finally {
      setActiveDownloadId(null);
    }
  };

  const openFileInNewTab = async (id, type = "pdf", title = "") => {
    try {
      setActiveDownloadId(id);
      const docType =
        type === "xlsx" ? "application/vnd.ms-excel" : "application/pdf";
      const response = await axios.post(
        `${IQ_API_BASE_URL}/company/download_file`,
        null,
        {
          responseType: "blob",
          params: { filingVersionId: id },
        }
      );
      const fileBlob = new Blob([response.data], { type: docType });
      const fileURL = window.URL.createObjectURL(fileBlob);
      window.open(fileURL, "_blank");

      const userStat = getUserStatsObject(
        tab_name,
        "document_view",
        "Page Source: " + competitorName,
        window.location.href,
        accountId
      );
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
    } catch (error) {
      console.error("Error opening the file in new tab", error);
    } finally {
      setActiveDownloadId(null);
    }
  };

  return (
    <>
      {documents?.length > 0 ? (
        <div className="table_technology_wrapper mt-4">
          <div className="head_top">
            <h5 className="main_head">{title}</h5>
          </div>
          <div className="table_block">
            <div className="table-responsive">
              <table className="table table-striped table-bordered new_comp_table">
                <thead>
                  <tr className="new_comp_tr">
                    <th scope="col" className="new_comp_th">
                      File Type
                    </th>
                    <th scope="col" className="new_comp_th">
                      Filing Date
                    </th>
                    <th scope="col" className="new_comp_th text-center">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {documents.map((document, index) => (
                    <tr className="new_comp_tr" key={index}>
                      <td className="new_comp_td">{document?.fileType}</td>
                      <td className="new_comp_td">
                        {document?.filingDate
                          ? formatDate(document?.filingDate, true)
                          : ""}
                      </td>
                      <td className="new_comp_td text-center">
                        {activeDownloadId === document.filingVersionId ? (
                          <StatusIndicator text="Preparing Your File" />
                        ) : (
                          <>
                            <a
                              className="download_block mr-3"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                downloadFile(
                                  document?.filingVersionId,
                                  "",
                                  document?.document_type ?? document?.fileType
                                );
                              }}
                            >
                              <i
                                className="fa fa-download"
                                aria-hidden="true"
                              ></i>{" "}
                              Download
                            </a>
                            <button
                              className="view_block "
                              onClick={() =>
                                openFileInNewTab(
                                  document?.filingVersionId,
                                  "",
                                  document?.document_type ?? document?.fileType
                                )
                              }
                            >
                              <i className="fa fa-eye" aria-hidden="true"></i>{" "}
                              View
                            </button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default memo(GenericDocumentTableComp);
